import { alertConstants } from '../constants/alert.constants';
import { IAlert } from '../actions/interfaces';

export function alertReducer(state = {}, action: IAlert) {
    switch (action.type) {
        case alertConstants.State.SUCCESS:
            return {
                type: 'alert-success',
                message: action.message,
            };
        case alertConstants.State.ERROR:
            return {
                type: 'alert-danger',
                message: action.message,
            };
        case alertConstants.State.CLEAR:
            return {
                type: 'alert-clear',
            };
        default:
            return state;
    }
}
